import Axios from "axios";
import Constants from "@/constants/Constants.js";

const CODE_UNAUTHORIZED = 401;
const CODE_NETWORK_CONNECTION_ERROR = -1;

export default{
	token: "",
	buildUrl(url){
		return Constants.MEDIA_LIBRARY_URL + url;
	},
	getToken(){
		let url = this.buildUrl("/api/v2/public/Token/") + Constants.MEDIA_LIBRARY_API_TOCKEN;
		return new Promise((resolve, reject) => {
			Axios.get(url)
				.then(response => {
					this.token = response.headers["x-token"];
					resolve(true);
				}).catch(error => {
					if (!error.response){
						reject(CODE_NETWORK_CONNECTION_ERROR);
						return;
					}
					if (error.response.status == CODE_UNAUTHORIZED){
						reject(CODE_UNAUTHORIZED);
						return;
					}

					reject("no connection");
				});
		});
	},
	doPost(url, data) {
		return new Promise(async (resolve, reject) => {
			Axios.post(url,
				data,
				{
					headers: {
						'Authorization': "bearer " + this.token
					}
				}
				).then((response) => {
					resolve(response);
				}).catch(async (error) => {
					if (error.response && (error.response.status == CODE_UNAUTHORIZED || error.response.status == CODE_NETWORK_CONNECTION_ERROR)){
						try{
							await this.getToken();
							resolve(this.doPost(url, data));
						} catch(e){
							reject(error);
						}
					} else {
						reject(error);
					}
				});
		});
	},
	doGet(url) {
		return new Promise(async (resolve, reject) => {
			Axios.get(url,
				{
					headers: {
						'Authorization': "bearer " + this.token
					}
				}).then((response) => {
					resolve(response);
				}).catch(async (error) => {
					if (error.response && error.response.status == CODE_UNAUTHORIZED){
						try{
							await this.getToken();
							resolve(this.doGet(url));
						} catch(e){
							reject(error);
						}
					} else {
						reject(error);
					}
				});
		});
	},
	findDictionary(dictionary){
		return this.doGet(this.buildUrl("/api/v2/cvomod/Dictionary/namespace/" + dictionary));
	},
	assetSearch(searchRequest) {
		return this.doPost(this.buildUrl("/api/v2/medialibrary/Asset/search"), searchRequest);
	},
	globalSearch(searchRequest) {
		return this.doPost(this.buildUrl("/api/v2/globalsearch/GlobalSearch/search"), searchRequest);
	},
	getPage(name){
		return this.doGet(this.buildUrl("/api/v2/newsletter/Page/" + name));
	},
	postNewsletter(subscription){
		return this.doPost(this.buildUrl("/api/v2/newsletter"), subscription);
	},
	getNewsletterCheckOTP(otp){
		return this.doGet(this.buildUrl("/api/v2/newsletter/checkOtp/" + otp));
	}
}